export enum ChatTestIds {
  CHAT_CONTAINER = 'chat-container',
}
